import { render, staticRenderFns } from "./Productpreview.vue?vue&type=template&id=7ed28c57&"
import script from "./Productpreview.vue?vue&type=script&lang=js&"
export * from "./Productpreview.vue?vue&type=script&lang=js&"
import style0 from "./Productpreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports